export default __webpack_public_path__ + "static/media/story_cover.0dc86e4c.png";